import React from "react";

import { Box } from "@material-ui/core";
import CustomButton from "../Button/CustomButton";
import CustomDialog from "./CustomDialog";

const CONFIDENTIAL_TITLE = "Highly Confidential Information Detected";

interface ConfidentialConfirmationDialogProps {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
  objectName?: string;
  text?: string;
}

const ConfidentialConfirmationDialog: React.FC<ConfidentialConfirmationDialogProps> = ({
  open,
  onCancel,
  onProceed,
  objectName = "object",
  text,
}) => {
  const defaultText = `The ${objectName} you are trying to submit contains highly confidential information. 
  Do you want to proceed and set the request to secret project?. Once you proceed this, you won't be able to change it back.`;
  return (
    <CustomDialog open={open} onClose={onCancel}>
      <Box p={3}>
        <h2>{CONFIDENTIAL_TITLE}</h2>
        <p>{text || defaultText}</p>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <CustomButton text="Cancel" onClick={onCancel} />
          <CustomButton primary text="Proceed" onClick={onProceed} style={{ marginLeft: 16 }} />
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default ConfidentialConfirmationDialog;
